/** Datas no fuso de São Paulo, formato pt-BR (docs/02, "Datas, números e textos"). */
export const FUSO = 'America/Sao_Paulo';

const dataHora = new Intl.DateTimeFormat('pt-BR', {
  timeZone: FUSO,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const data = new Intl.DateTimeFormat('pt-BR', {
  timeZone: FUSO,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

/** `04/10/2026 10:15` */
export function formatarDataHora(instante: Date | string): string {
  return dataHora.format(new Date(instante)).replace(',', '');
}

/** `04/10/2026` */
export function formatarData(instante: Date | string): string {
  return data.format(new Date(instante));
}

const dia = new Intl.DateTimeFormat('en-CA', {
  timeZone: FUSO,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

/** Hoje em São Paulo, no formato de dia do backend: `2026-10-04`. */
export function hojeEmSaoPaulo(agora: Date = new Date()): string {
  return dia.format(agora);
}

/**
 * Dia do backend (`2026-12-31`, sem hora) → `31/12/2026`. Não passa por `Date`: meia-noite UTC
 * cairia no dia anterior em São Paulo.
 */
export function formatarDia(aaaaMmDd: string): string {
  const [ano, mes, diaDoMes] = aaaaMmDd.split('-');
  return `${diaDoMes ?? ''}/${mes ?? ''}/${ano ?? ''}`;
}

/** Soma (ou subtrai) dias a um dia do backend, sem fuso: `somarDias('2026-10-04', -29)` → `2026-09-05`. */
export function somarDias(aaaaMmDd: string, dias: number): string {
  const [ano = 0, mes = 1, diaDoMes = 1] = aaaaMmDd.split('-').map(Number);
  return new Date(Date.UTC(ano, mes - 1, diaDoMes + dias)).toISOString().slice(0, 10);
}
